import {
  Copy,
  Flex,
  Square,
  Image,
  SvgX,
} from '@grubhubprod/gh-cookbook-react/dist';
import classnames from 'classnames';
import React, { useState } from 'react';
import NavBarLink from 'src/components/Navigation/NavBarLink';
import { isPhoneView } from 'src/utilities/useScreenSizes';

const NAV_MENU_TOP_OFFSET = '11px';

export interface INavRoute {
  text: string;
  page: string;
}

export interface INavBarLinksWrapperProps {
  routes: INavRoute[];
  onMenuToggle: (isOpen: boolean) => void;
}

export default function NavBarLinksWrapper({
  routes,
  onMenuToggle,
}: INavBarLinksWrapperProps): JSX.Element {
  const isTablet = !isPhoneView();
  const [openMenu, setOpenMenu] = useState(false);

  function getNavLinks(): JSX.Element[] {
    return routes.map((item, index) => (
      <NavBarLink
        key={item.text}
        text={item.text}
        page={item.page}
        isLast={index === routes.length - 1}
      />
    ));
  }

  function onMenuToggleClick(): void {
    setOpenMenu(!openMenu);
    // Do not hide nav bar on scroll when mobile menu is open
    onMenuToggle(!openMenu);
  }

  return (
    <>
      {isTablet ? (
        <Flex
          bg="globals.white"
          flexDirection="row"
          justifyContent="flex-end"
          alignContent="flex-end"
        >
          {getNavLinks()}
        </Flex>
      ) : (
        <Square inset="sm">
          <div
            className={classnames('', {
              navDropdown: isPhoneView,
              show: openMenu,
            })}
          >
            <Flex
              bg="globals.white"
              justifyContent="flex-center"
              alignContent="end"
              data-testid="nav-dropdown-toggle"
              className="navDropdownToggle"
              onClick={onMenuToggleClick}
            >
              <Copy variant="body" color="interactive">
                {openMenu ? (
                  <SvgX size="24px" />
                ) : (
                  <Image
                    src="https://res.cloudinary.com/grubhub-assets/image/upload/v1606853743/icon-svg/hamburger-menu.svg"
                    alt="Hamburger menu"
                  />
                )}
              </Copy>
            </Flex>

            <Flex
              mt={NAV_MENU_TOP_OFFSET}
              bg="globals.white"
              flexDirection="column"
              justifyContent="flex-end"
              alignContent="center"
              data-testid="nav-dropdown-menu"
              dimension="2"
              className="navDropdownMenu"
            >
              {getNavLinks()}
            </Flex>
          </div>
        </Square>
      )}
    </>
  );
}
